export enum ProfileType {
  EGI = 'egi',
  FCR = 'fcr',
  EFI = 'efi',
  MORTALITY = 'mort',
  TEMPERATURE = 'temp',
  FEED_STRATEGY = 'feed',
}

export enum ProfileSubType {
  EGI = 'egi',
  EFI = 'efi',
  FCR = 'fcr',
  MORTALITY = 'mort',
  TEMPERATURE = 'temp',
  FEED_STRATEGY = 'feed',
}
